// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2EfOA","col":"CardReaderDesc_col__dCsS-","label":"CardReaderDesc_label__2AdYw"};